import { redirect } from "react-router-dom";

/**
 * Unauthenticated users are sent to `/signup` (sign-in and sign-up) with a safe
 * relative `returnUrl` so they return to the page they tried to open.
 */
export function redirectToSignupWithReturnUrl(request: Request) {
  const url = new URL(request.url);
  const returnPath = `${url.pathname}${url.search}`;
  return redirect(`/signup?returnUrl=${encodeURIComponent(returnPath)}`);
}
